/* global TradeInValuations */

import React, { Component } from "react"
import PropTypes from "prop-types"
import "intersection-observer"
import ChatBubble from "./icons/ChatBubble.svg?react"
import Template from "component_library/styles/Template"
import DepreciationAndUrgency from "component_library/components/react/DepreciationAngUrgency"
import PricingDetails from "component_library/components/react/valuation_result/PricingDetails"

class TradeInResultBeta extends Component {
  static propTypes = {
    estimationCar: PropTypes.object.isRequired,
    headline: PropTypes.string,
    estimation: PropTypes.string,
    estimationBasedOn: PropTypes.string,
    resultHeading: PropTypes.string,
    pricingExplanation: PropTypes.string,
    pricingResult: PropTypes.string,
    estimationInfo: PropTypes.object.isRequired,
    urgencyIndicators: PropTypes.object.isRequired,
    displayValuation: PropTypes.bool,
    whyChangeNowHeadline: PropTypes.string,
    depreciationInfo: PropTypes.object,
    priceAffectedByRules: PropTypes.bool,
    showAutouncleStyling: PropTypes.bool,
    trackFunction: PropTypes.func,
    positiveRulesInfo: PropTypes.shape({
      positiveRules: PropTypes.array,
      othersPrice: PropTypes.string,
      othersOffer: PropTypes.string,
      whyPayMoreHeadline: PropTypes.string,
    }),
  }

  initTradeInResultTracking = () => {
    let trackedElements = document.querySelectorAll(".tracked-box")

    // Track elements that are included on the trade-in result page
    trackedElements.forEach((element) => {
      const fieldName = element.getAttribute("data-name")
      this.props.trackFunction({
        entity: "valuation_result",
        element: fieldName,
        action: "displayed",
        type: "micro_proceeding",
        flow: "trade_in",
      })
    })
    // Track elements that user has seen on trade-in result page
    const trackElementsInTradeInResultView = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          const fieldName = entry.target.getAttribute("data-name")
          this.props.trackFunction({
            entity: "valuation_result",
            element: fieldName,
            action: "seen",
            type: "micro_proceeding",
            flow: "trade_in",
          })
          observer.unobserve(entry.target)
        }
      })
    }

    const config = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    }

    const io = new IntersectionObserver(
      trackElementsInTradeInResultView,
      config
    )

    trackedElements.forEach((element) => {
      io.observe(element)
    })
  }

  componentDidMount() {
    TradeInValuations.hideHeaderTitle()

    // Because another event is tracked sync right after this component mounts,
    // we need to make sure this event is fired after that one
    setTimeout(() => {
      this.props.trackFunction({
        entity: "valuation_result",
        action: "displayed",
        details: this.props.displayValuation
          ? "with valuation"
          : "without valuation",
        type: "macro_proceeding",
        flow: "trade_in",
      })
    }, 0)

    this.initTradeInResultTracking()

    // Removes margin top for the header set up in CarAssemblage Component
    // when running Lead Collector Stepper experiment
    const container = document.querySelector("header")
    if (container) container.style.marginTop = "0px"

    // Removes the main headline
    const headline = document.querySelector("header h1")
    if (headline) headline.style.display = "none"

    // Sets up the width on smaller screens to 100% width
    // Previously set up max-width: 300px because of arrow in CarAssemblage form
    const contentWrapper = document.querySelector(".content-wrapper")
    if (contentWrapper) {
      contentWrapper.style.maxWidth = "500px"
      contentWrapper.style.width = "100%"
    }
  }

  render() {
    const { props } = this
    const {
      depreciationInfo,
      urgencyIndicators,
      estimationCar,
      positiveRulesInfo,
    } = this.props

    return (
      <Template>
        <div className="result beta branded-container">
          {props.resultHeading && (
            <div className="result-heading">
              <div className="icon">
                <ChatBubble />
              </div>
              <p dangerouslySetInnerHTML={{ __html: props.resultHeading }} />
            </div>
          )}
          <h1>{props.headline}</h1>
          <PricingDetails
            car={estimationCar}
            estimationInfo={props.estimationInfo}
            displayValuation={props.displayValuation}
            pricingResult={props.pricingResult}
            estimationBasedOn={props.estimationBasedOn}
            priceAffectedByRules={props.priceAffectedByRules}
            estimation={props.estimation}
            positiveRulesInfo={positiveRulesInfo}
            pricingExplanation={props.pricingExplanation}
            showAutouncleStyling={props.showAutouncleStyling}
            trackFunction={props.trackFunction}
          />
          <div className="extra-result-container">
            <DepreciationAndUrgency
              urgencyIndicators={urgencyIndicators}
              depreciationInfo={depreciationInfo}
              headline={props.whyChangeNowHeadline}
            />
          </div>
        </div>
      </Template>
    )
  }
}

export default TradeInResultBeta
